import util from './util'
import config from './../config/pageContent.js'

window.I = window.I || {}

window.I.$Rangers = window.collectEvent

window.I.$RangersEvent = function(name, params) {
    // if (!window.I.dataFinder_id) return
    window.I.$Rangers(name, params)
}

// 初始化dataFinder
;(() => {
    const urlParams = (() => {
        let urlStrs = decodeURI(location.search || location.hash),
            urlParasm = urlStrs.split("?"),
            urlParamsStrs = urlParasm.length == 1 ? urlParasm[0] : urlParasm[1];
        let params = util.parser(urlParamsStrs);
    
        return params;
    })()

    console.log(urlParams, 'urlParams')

    const app_id = urlParams.app_id || (config[urlParams.theme] && config[urlParams.theme]['app_id'])

    if (app_id) {
        // 面料海报埋点
        if (urlParams.theme === 'mianliao') {
            window.collectEvent('init', { 
                app_id: Number(app_id),
                channel: 'cn',
                log: true,
                autotrack: true  //默认关闭，需要热力图及圈选功能可开启
            });
            window.collectEvent('config', {
                client: 'h5'
            })
            window.collectEvent('start')

            return
        }

        if (urlParams.theme || (urlParams.appId && urlParams.exhibitionId)) {
            window.I.dataFinder_id = Number(app_id)

            window.I.$RangersEvent('init', { 
                app_id: Number(app_id),
                channel: 'cn',
                autotrack: true  //默认关闭，需要热力图及圈选功能可开启
            });

            window.I.$RangersEvent('config', {
                login_state: urlParams.login_state || '',
                project_id: urlParams.project_id || '',
                App_id: urlParams.appId,
                exhibition_id: urlParams.exhibitionId,
                role_id: urlParams.role_id || '',
                exhibitors_id: urlParams.exhibitors_id || '',
                exhibitors_name: urlParams.exhibitors_name || '',
                login_role: urlParams.showType === 'VISITOR' ? 'visitor' : 'exhibitors',
                useraccount_id: urlParams.useraccount_id || '',
                user_unique_id: urlParams.useraccount_id || '',
                exhibitionId: urlParams.exhibitionId,
                appId: urlParams.appId,
                client: urlParams.client || '',
                userAccountId: urlParams.userAccountId
            })
            window.I.$RangersEvent('start')
        }
    }

    
})();